import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { trpc } from "../lib/trpc.js";
import { Button } from "./ui/Button.js";
import { LanguageSelector } from "./LanguageSelector.js";
import { NotificationBell } from "./NotificationBell.js";

export function NavActions() {
  const { t } = useTranslation();
  const logout = trpc.auth.logout.useMutation({
    onSuccess: () => { window.location.href = "/login"; },
  });

  return (
    <div className="flex items-center gap-3 flex-shrink-0">
      <NotificationBell />
      <Link
        to="/reading-list"
        className="text-sm hidden sm:block"
        style={{ color: "var(--color-muted-foreground)", textDecoration: "none" }}
        onMouseEnter={(e) => (e.currentTarget.style.color = "var(--color-foreground)")}
        onMouseLeave={(e) => (e.currentTarget.style.color = "var(--color-muted-foreground)")}
      >
        {t("nav.myBooks")}
      </Link>
      <Link
        to="/account"
        className="text-sm hidden sm:block"
        style={{ color: "var(--color-muted-foreground)", textDecoration: "none" }}
        onMouseEnter={(e) => (e.currentTarget.style.color = "var(--color-foreground)")}
        onMouseLeave={(e) => (e.currentTarget.style.color = "var(--color-muted-foreground)")}
      >
        {t("nav.settings")}
      </Link>
      <LanguageSelector />
      <Button
        variant="ghost"
        size="sm"
        loading={logout.isPending}
        onClick={() => logout.mutate()}
      >
        {t("nav.signOut")}
      </Button>
    </div>
  );
}
